export default `
  query getAutomatedEmailSettings {
    getAutomatedEmailSettings {
      enabled
      senderEmail
      emailSubject
      emailBody
    }
  }
`
